import css from './definitionPane.module.scss';

import { memo } from 'react';

import DisplayTemplate from 'core/ui/DisplayTemplate';
import LangIcon from 'core/ui/LangIcon';

const Definition: React.FC<{ lang: TLangAndNone; text: string }> = ({
  lang,
  text,
}) => (
  <div className={css.definition} lang={lang}>
    {lang !== 'none' && <LangIcon className={css.langIcon} lang={lang} />}{' '}
    <DisplayTemplate children={text} />
  </div>
);

export default memo(Definition);
